import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'
import { NavLink, Row, Col, Spinner, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Link } from 'react-router-dom';
import { MultipleChoice } from './questions/MultipleChoice';
import {
    CONFIG_BASE_API_URL,
} from '../constans';

export class TrainingExamPage extends Component {
    static displayName = TrainingExamPage.name;

    constructor(props) {
        super(props);
        this.state = { trainingDetail: [], finished : false, loading: true };

        this.renderAvailableTrainings = this.renderAvailableTrainings.bind(this);
        this.confirmAnswer = this.confirmAnswer.bind(this);
    }

    componentDidMount() {
        new Image().src = '/img/button_confirm.png';
        new Image().src = '/img/button_confirm_disabled.png';
        this.getQuestionData();
    }

    async confirmAnswer(selectedAnswerId) {
        this.setState({ loading: true });
        await this.submitAnswer(selectedAnswerId);
    }

    renderAvailableTrainings() {
        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <MultipleChoice question={this.state.trainingQuestion.questionText} onConfirmAnswer={this.confirmAnswer} answerOptions={this.state.trainingQuestion.options} imageUrl={this.state.trainingQuestion.imageUrl}></MultipleChoice>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    render() {
        let contents = this.state.loading
            ? <Row><div className="col-sm center-loading-spinner"> <Spinner className="spinner-settings" type="border" color="primary" /> <span className="sr-only">Bezig met vragen ophalen...</span></div></Row>
            : this.renderAvailableTrainings();
        return (
            <React.Fragment >
                {contents}
                <Modal isOpen={this.state.finished} unmountOnClose={true}  >
                    <ModalHeader>Dat was het!</ModalHeader>
                    <ModalBody>
                        <p>Je hebt alle vragen beantwoord en wij hebben deze verwerkt. Benieuwd naar je resultaat?</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button tag={Link} color="primary" to={"/trainingresult/" + this.state.trainingResultId}>Laat het resultaat zien!</Button>
                         
                    </ModalFooter>
                    </Modal>
            </React.Fragment>
        );
    }
    //getQuestionData
    async getQuestionData() {
        const token = await authService.getAccessToken();
        const response = await fetch(CONFIG_BASE_API_URL + '/training/' + this.props.match.params.id + '/actions/getquestion/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (!data.isSuccess) {
            // voor nu niks later generieke toast laten zien met foutmelding
        }
        this.setState({ trainingQuestion: data.responseData, loading: false });
    }

    //submitAnswer
    async submitAnswer(answerId) {
        const token = await authService.getAccessToken();
        const response = await fetch(CONFIG_BASE_API_URL + '/training/' + this.props.match.params.id + '/actions/submitanswer/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json; charset=utf-8' },
            method: "POST",
            body: answerId
        });
        const data = await response.json();
        if (!data.isSuccess) {
            // voor nu niks later generieke toast laten zien met foutmelding
        }
        if (!data.responseData.isNextQuestionAvailable) {
            this.setState({ trainingResultId: data.responseData.trainingResultId, finished : true, loading: false });
        }
        else {
            await this.getQuestionData();
        }
    }
}